export const FeatureFlags = {
    displaypdf: 'displaypdf',
    uploadcds: 'uploadcds',
    viewprofile: 'viewprofile',
    downloadallbutton: 'downloadallbutton',
    mediauploadpage: 'mediauploadpage'
};